<template>
  <div class="set-exam container">
    <div class="box">
      <div class="header">
        <el-page-header
          @back="$router.go(-1)"
          :content="$route.query.examId ? '编辑试卷' : '新建试卷'"
        >
        </el-page-header>
        <el-input
          v-model="form.title"
          size="small"
          placeholder="请输入试卷名称"
        ></el-input>
        <!-- <div class="setting">
          <el-form
            :model="form"
            size="small"
            label-width="80px"
            label-position="left"
          >
            <el-form-item prop="scoreSet" label="评分机制">
              <el-radio-group v-model="form.scoreSet">
                <el-radio :label="0"
                  >百分制
                  <span style="color: #909399"
                    >（平均分配每道题的分值）</span
                  ></el-radio
                >
                <el-radio :label="1"
                  >自定义
                  <span style="color: #909399"
                    >（自行设置每道题的分值）</span
                  ></el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              prop="typeSet"
              label="题型设置"
              style="margin-bottom: 0"
            >
              <el-radio-group v-model="form.typeSet">
                <el-radio :label="0">按题型归类</el-radio>
                <el-radio :label="1">不按题型归类</el-radio>
              </el-radio-group></el-form-item
            >
          </el-form>
        </div> -->
        <el-button
          class="submit-btn"
          size="mini"
          type="primary"
          @click="handleSubmit"
          >完成</el-button
        >
      </div>
      <div class="body">
        <div class="left-list">
          <div class="head">
            <span>题量{{ form.questionList.length }}，</span>
            <span>总分{{ sum(form.questionList) }}</span>
          </div>
          <!-- 按题型分类 -->
          <div class="q-list type-sort">
            <div
              class="one-type"
              v-for="(item, idx) in cQuestionList"
              :key="idx"
            >
              <p
                class="type-title"
                @mouseenter="editTypeScore(item.type, item.totalScore)"
                @mouseleave="fixTypeScore"
              >
                {{ idx + 1 }}. {{ checkType(item.type) }}
                <span
                  >(共{{ item.questionList.length }}题，
                  <el-input-number
                    class="score_input"
                    :ref="'input-' + item.type"
                    v-if="editing == item.type"
                    v-model="totalScore"
                    :min="0"
                    :controls="false"
                    size="mini"
                    @change="(e) => onChange(e, item.type)"
                  ></el-input-number>
                  <span v-else>{{ item.totalScore }}</span>
                  分)</span
                >
              </p>
              <vuedraggable
                class="vue-draggable"
                v-model="item.questionList"
                tag="ul"
                draggable=".draggable-item"
                animation="300"
                @start="onDragStart"
                @end="onDragEnd"
              >
                <li
                  class="row draggable-item"
                  :class="{ active: currentEdit.id == q.id }"
                  v-for="(q, i) in item.questionList"
                  :key="q.id"
                  @click="currentEdit = q"
                >
                  <span class="idx">{{ i + 1 }}</span>
                  <span class="q-stem">{{ q.question }}</span>
                  <i
                    class="el-icon-delete"
                    @click="handleDel(q.id, q.questionId)"
                  ></i>
                </li>
              </vuedraggable>
            </div>
          </div>
          <!-- 不按题型分类 -->
          <!-- <div class="q-list">
            <vuedraggable
              class="vue-draggable"
              v-model="form.questionList"
              tag="ul"
              draggable=".draggable-item"
              animation="300"
              @start="onDragStart"
              @end="onDragEnd"
            >
              <li
                class="row draggable-item"
                :class="{ active: currentEdit.id == item.id }"
                v-for="(item, idx) in form.questionList"
                :key="item.id"
                @click="currentEdit = item"
              >
                <span class="idx">{{ idx + 1 }}</span>
                <span class="q-type">({{ checkType(item.type) }})</span>
                <span class="q-stem">{{ item.question }}</span>
                <i
                  class="el-icon-delete"
                  @click="handleDel(item.id)"
                ></i>
              </li>
            </vuedraggable>
          </div> -->
        </div>
        <div class="right-detail">
          <div class="btns">
            <span style="margin-right: 15px; color: #909399">添加题目</span>
            <div
              class="type-btn"
              v-for="item in list"
              :key="item.type"
              @click="handleAddQuestion(JSON.parse(JSON.stringify(item)))"
            >
              {{ checkType(item.type) }}
            </div>
            <el-button type="text" style="float: right" @click="show = true"
              >从题库选题</el-button
            >
          </div>
          <div class="edit-area">
            <p v-if="currentEdit" style="padding: 20px">
              {{ checkType(currentEdit.type) }}
            </p>
            <component
              v-if="currentEdit"
              :is="currentEdit.type"
              :form="currentEdit"
              :isEdit="true"
            />
          </div>
        </div>
      </div>
    </div>

    <chooseQuestion
      :show="show"
      @addQuestion="addQuestion"
      @closeChoose="closeChoose"
    />
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
import RADIO from "@/components/questionTemplate/radio";
import CHECKBOX from "@/components/questionTemplate/checkbox";
import BOOLEAN from "@/components/questionTemplate/boolean";
import SUPPLY from "@/components/questionTemplate/supply";
import ANSWER from "@/components/questionTemplate/answer";
import { checkType, getUID } from "@/utils/index";
import chooseQuestion from "../../courseDetail/activity/quiz/components/chooseQuestion";
import { saveExam, examInfo, editExam, delExamQuestion } from "@/api/exam";

export default {
  components: {
    vuedraggable,
    RADIO,
    CHECKBOX,
    BOOLEAN,
    SUPPLY,
    ANSWER,
    chooseQuestion,
  },
  data() {
    return {
      checkType,
      form: {
        classId: this.$route.query.id,
        title: "新建试卷",
        questionList: [],
      },
      list: [
        {
          id: null,
          type: "RADIO",
          question: "",
          optionList: [
            {
              tag: "A",
              option: "",
            },
            {
              tag: "B",
              option: "",
            },
            {
              tag: "C",
              option: "",
            },
          ],
          answerList: [],
          score: 1,
        },
        {
          id: null,
          type: "CHECKBOX",
          question: "",
          optionList: [
            {
              tag: "A",
              option: "",
            },
            {
              tag: "B",
              option: "",
            },
            {
              tag: "C",
              option: "",
            },
          ],
          answerList: [],
          score: 2,
        },
        {
          id: null,
          type: "BOOLEAN",
          question: "",
          optionList: [
            {
              tag: "A",
              option: "对",
            },
            {
              tag: "B",
              option: "错",
            },
          ],
          answerList: [],
          score: 1,
        },
        {
          id: null,
          type: "SUPPLY",
          question: "",
          answerList: [],
          emptyCount: 1,
          score: 3,
        },
        {
          id: null,
          type: "ANSWER",
          question: "",
          answerList: [],
          score: 5,
        },
      ],
      show: false,
      currentEdit: null,
      editing: null,
      totalScore: null,
    };
  },
  created() {
    let examId = this.$route.query.examId;
    examId && this.getInfo(examId);
  },
  computed: {
    cQuestionList() {
      return this.classify(this.form.questionList);
    },
  },
  methods: {
    // 获取试卷详情
    getInfo(examId) {
      this.$loading.show();
      examInfo(examId).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          data.questionList.forEach((item) => {
            item.id = item.questionId;
          });
          this.form = data;
          this.currentEdit = this.form.questionList[0];
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 点击添加题目
    handleAddQuestion(question) {
      question.id = getUID();
      this.form.questionList.push(question);
      this.currentEdit =
        this.form.questionList[this.form.questionList.length - 1];
    },
    // 计算总分
    sum(arr) {
      return Number(
        arr
          .reduce((prev, curr) => {
            return curr.score + prev;
          }, 0)
          .toFixed(1)
      );
    },
    // 按题型分类
    classify(questions) {
      let arr = [];
      let radios = questions.filter((item) => {
        return item.type == "RADIO";
      });
      if (radios.length > 0)
        arr.push({
          type: "RADIO",
          questionList: radios,
          totalScore: this.sum(radios),
        });

      let checkboxs = questions.filter((item) => {
        return item.type == "CHECKBOX";
      });
      if (checkboxs.length > 0)
        arr.push({
          type: "CHECKBOX",
          questionList: checkboxs,
          totalScore: this.sum(checkboxs),
        });

      let booleans = questions.filter((item) => {
        return item.type == "BOOLEAN";
      });
      if (booleans.length > 0)
        arr.push({
          type: "BOOLEAN",
          questionList: booleans,
          totalScore: this.sum(booleans),
        });

      let supplys = questions.filter((item) => {
        return item.type == "SUPPLY";
      });
      if (supplys.length > 0)
        arr.push({
          type: "SUPPLY",
          questionList: supplys,
          totalScore: this.sum(supplys),
        });

      let answers = questions.filter((item) => {
        return item.type == "ANSWER";
      });
      if (answers.length > 0)
        arr.push({
          type: "ANSWER",
          questionList: answers,
          totalScore: this.sum(answers),
        });
      return arr;
    },
    editTypeScore(type, totalScore) {
      this.editing = type;
      this.totalScore = totalScore;
      this.$nextTick((_) => {
        this.$refs[`input-${type}`][0].focus();
      });
    },
    // 修改题型分数
    onChange(e, type) {
      let fixArr = this.form.questionList.filter((item) => {
        return item.type == type;
      });
      let avg = (e / fixArr.length).toFixed(1);
      this.form.questionList.forEach((item) => {
        if (item.type == type) item.score = Number(avg);
      });
    },
    fixTypeScore() {
      this.editing = null;
    },
    // 拖拽排序
    onDragStart(e) {
      e.target.classList.add("hideShadow");
    },
    onDragEnd(e) {
      e.target.classList.remove("hideShadow");
    },
    // 删除
    handleDel(id, questionId) {
      this.$confirm("删除后无法恢复，确认删除？", {
        type: "warning",
      })
        .then(() => {
          if (questionId) {
            delExamQuestion(questionId).then((res) => {});
          }
          this.form.questionList = this.form.questionList.filter((item) => {
            return item.id != id;
          });
          this.currentEdit = this.form.questionList[0] || {};
        })
        .catch(() => {});
    },
    // 从题库选题
    addQuestion(questions) {
      questions.forEach((item) => {
        if (item.type == "RADIO" || item.type == "BOOLEAN") {
          item.score = 1;
        } else if (item.type == "CHECKBOX") {
          item.score = 2;
        } else if (item.type == "SUPPLY") {
          item.score = 3;
        } else {
          item.score = 5;
        }

        item.id = item.questionId;
        delete item.questionId;

        let isExist = this.form.questionList.some((q) => {
          return q.id == item.id;
        });
        if (!isExist) this.form.questionList.push(item);
      });
      this.currentEdit = this.form.questionList[0];
    },
    closeChoose() {
      this.show = false;
    },
    // 保存
    handleSubmit() {
      let arr = [];
      this.cQuestionList.forEach((item) => {
        arr = arr.concat(item.questionList);
      });
      this.form.questionList = arr;
      // console.log(this.form);
      if (this.form.questionList.length == 0) {
        this.$message.error("请先添加试题");
        return;
      }

      let check = this.form.questionList.every((item) => {
        return this.checkQuestion(item) === true;
      });
      if (!check) return;

      this.form.questionList.forEach((item) => {
        delete item.id;
      });

      let examId = this.$route.query.examId;
      this.$loading.show();
      (examId ? editExam : saveExam)(this.form).then(({ code, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.$message.success(examId ? "修改成功" : "创建成功");
          this.$router.replace({
            path: "/classCourse/exam/examBank",
            query: {
              id: this.$route.query.id,
              courseId: this.$route.query.courseId,
            },
          });
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 空验证
    checkQuestion(question) {
      if (!question.question) {
        this.$message.error("题干不能为空");
        return false;
      } else if (!question.score) {
        this.$message.error("题目分值不能为空");
        return false;
      } else if (question.type != "ANSWER") {
        if (question.answerList.length <= 0 || !question.answerList[0]) {
          this.$message.error("答案不能为空");
          return false;
        }
      }
      if (question.type == "RADIO" || question.type == "CHECKBOX") {
        if (
          question.optionList.some((item) => {
            return item.option == "";
          })
        ) {
          this.$message.error("选项不能为空");
          return false;
        }
      } else if (question.type == "SUPPLY") {
        if (
          question.answerList.some((item) => {
            return item == "";
          })
        ) {
          this.$message.error("答案不能为空");
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.set-exam {
  height: 100%;
  text-align: left;
  .box {
    .header {
      position: relative;
      padding: 24px;
      border-radius: 8px;
      background-color: #fff;
      ::v-deep .el-page-header {
        margin-bottom: 10px;
        .el-page-header__content {
          font-size: 16px;
        }
      }
      .setting {
        margin-top: 5px;
        ::v-deep .el-form-item {
          margin-bottom: 5px;
          .el-form-item__label {
            font-weight: bold;
          }
        }
      }
      .submit-btn {
        position: absolute;
        top: 20px;
        right: 24px;
        width: 100px;
      }
    }
    .body {
      margin-top: 20px;
      height: 650px;
      .left-list {
        display: inline-block;
        margin-right: 20px;
        width: 280px;
        height: 100%;
        border-radius: 8px;
        background-color: #fff;
        vertical-align: top;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }
        .head {
          padding: 15px;
          color: #909399;
        }
        .q-list {
          &.type-sort {
            .type-title {
              padding: 0 15px;
              height: 46px;
              line-height: 46px;
              font-weight: bold;
              ::v-deep .score_input {
                width: 40px;
                .el-input__inner {
                  padding: 0;
                  height: 25px;
                }
              }
            }
            .idx {
              margin-right: 5px;
            }
            .q-stem {
              max-width: 200px !important;
            }
          }
          .row {
            padding: 10px 15px;
            .idx {
              vertical-align: middle;
            }
            .q-type {
              margin: 0 5px;
              color: #909399;
              vertical-align: middle;
            }
            .q-stem {
              display: inline-block;
              max-width: 150px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              vertical-align: middle;
            }
            .el-icon-delete {
              float: right;
              font-size: 16px;
              color: #909399;
              cursor: pointer;
              opacity: 0;
              &:hover {
                color: #3a8bff;
              }
            }
            &.active {
              background: #f0f6ff;
              color: #3a8bff;
            }
            &:hover {
              background: #f0f6ff;
              color: #3a8bff;
              .el-icon-delete {
                opacity: 1;
              }
            }
          }
        }

        // 拖拽
        .vue-draggable {
          &.hideShadow {
            .shadow {
              display: none;
            }
          }
        }
      }
      .right-detail {
        display: inline-block;
        width: calc(100% - 280px - 20px);
        height: 100%;
        vertical-align: top;
        .btns,
        .edit-area {
          width: 100%;
          border-radius: 8px;
          background-color: #fff;
          &.btns {
            margin-bottom: 20px;
            padding: 15px;
            height: 70px;
            overflow: hidden;
            .type-btn {
              display: inline-block;
              margin-right: 20px;
              width: 100px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #333;
              border: 1px solid #e1e1e5;
              border-radius: 4px;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.3s ease;
              &:hover {
                border-color: #1890ff;
              }
            }
          }
          &.edit-area {
            padding-right: 30px;
            height: calc(100% - 70px - 20px);
            overflow-y: auto;
            &::-webkit-scrollbar {
              width: 4px;
              background-color: #f5f5f5;
            }

            &::-webkit-scrollbar-track {
              box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
              -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
              border-radius: 10px;
              background-color: #f5f5f5;
            }

            &::-webkit-scrollbar-thumb {
              border-radius: 10px;
              box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
              -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
              background-color: #c8c8c8;
            }
          }
        }
      }
    }
  }
}
</style>